module.exports = __webpack_public_path__ + "nu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/nu.svg
// module id = 741
// module chunks = 0